import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

import { ui } from '@/constants';

@Component({
  name: 'CmgEmployeeRewardsHowItWorksModal',
})
export default class CmgEmployeeRewardsHowItWorksModal extends Vue {
	get headline(): string | undefined { 
		return this.$services.config.getEmployeeRewardsHowItWorksModal()?.headline;
	}

	get subHeadline(): string | undefined {
		return this.$services.config.getEmployeeRewardsHowItWorksModal()?.subHeadline;
	}

	get bodyText(): string | undefined {
		return this.$services.config.getEmployeeRewardsHowItWorksModal()?.bodyText;
	}

  get visible(): boolean {
    return this.$appStore.state.ui.modals.employeeRewardsHowItWorksModal.visible;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get iconVerifiedUrl(): string {
    return this.$appStore.state.cms.images.logos.iconVerified.default;
  }

  onClose() {
    this.$services.ui.setModalVisibility('employeeRewardsHowItWorksModal', false);
  }
}
